import React from 'react'
import { GrSystem } from 'react-icons/gr'
import TechnologyServicePage from '../components/TechnologyServicePage'

const capabilities = [
    { title: 'Enterprise Integration', description: 'Connect core systems so data and workflows move reliably.' },
    { title: 'API Management', description: 'Design, secure, document, and govern reusable APIs.' },
    { title: 'Middleware Development', description: 'Build integration layers between legacy and modern platforms.' },
    { title: 'Payment Gateway Integration', description: 'Connect payment providers securely into business platforms.' },
    { title: 'Third-Party Integration', description: 'Link external tools, services, and vendor platforms.' },
    { title: 'Government Platform Integration', description: 'Integrate with public sector platforms and digital services.' },
    { title: 'ERP & CRM Integration', description: 'Synchronize enterprise, customer, and operational data.' },
    { title: 'Identity Management', description: 'Connect authentication, authorization, and user identity systems.' }
]

const SystemIntegration = () => (
    <TechnologyServicePage
        badge="Systems Integration"
        title="Connect platforms, data, APIs, and services into one working ecosystem."
        description="We integrate enterprise systems, APIs, middleware, payment gateways, third-party tools, government platforms, ERP, CRM, and identity services."
        metaDescription="Systems integration for enterprise platforms, API management, middleware, payment gateways, third-party systems, government platforms, ERP, CRM, and identity management."
        icon={<GrSystem className="text-sm" />}
        capabilities={capabilities}
        featuredVisual={{
            image: '/assets/systemintegration360.jpeg',
            alt: 'VRIFY Systems 360 Integration Platform',
            eyebrow: 'Featured systems integration platform',
            title: 'Meet VRIFY Systems 360.',
            description: 'A connected systems integration platform that brings essential enterprise, API, middleware, and service tools into one clear digital experience.',
            points: [
                'Enterprise systems & APIs',
                'Middleware & service layers',
                'Payment, third-party & government platforms'
            ]
        }}
        outcomes={[
            { title: 'Less fragmentation', description: 'Connect separate systems into smoother digital workflows.' },
            { title: 'Reliable data movement', description: 'Use APIs and middleware to synchronize information securely.' },
            { title: 'Stronger access control', description: 'Improve identity, authentication, and integrated platform governance.' }
        ]}
        highlights={[
            { title: 'Connect', description: 'Link enterprise, government, payment, and third-party platforms.' },
            { title: 'Govern', description: 'Manage APIs, identity, security, and integration standards.' },
            { title: 'Synchronize', description: 'Move data across ERP, CRM, middleware, and operational systems.' }
        ]}
        cta={{
            eyebrow: 'Connected systems',
            title: 'Make your technology stack work together.',
            description: 'We help organizations remove silos and build secure, API-first digital ecosystems.'
        }}
    />
)

export default SystemIntegration
